import { FilterDescriptor, toODataString } from '@progress/kendo-data-query';
import { IEngineODataState } from '../../../engine-sdk/contract/odata/iodata-state.model';
import { GuidService } from '../../services/guid.service';
import { flatten } from '../../../shared/grid/grid.component';

export class EngineODataStateParser {
  static getKeywordFilterQuery(filter: FilterDescriptor): string | undefined {
    const value = filter.value;
    if (value?.keyword === undefined) return undefined;

    return `${filter.field} ${this.mapFilterOperator(filter.operator as string)} ${value.keyword}`;
  }

  static normalizeGuidFilterValue(value: any): any {
    if (!value || typeof value !== 'object') return value;

    return value.value ?? value.id ?? value.Id ?? value.ID ?? value;
  }

  static toODataString(state: IEngineODataState, utcDates: boolean = false) {
    if (state) {
      const randomToken = GuidService.generateNew();

      if (state?.filter?.filters?.length > 0)
        for (let filter of flatten(state.filter).filter(x => x['type'] == 'guid'))
          filter.value = `guid-${randomToken}${filter.value}guid-${randomToken}`

      let odataString = toODataString(state, { utcDates });
      odataString = odataString
        .split(`'guid-${randomToken}`).join('')
        .split(`guid-${randomToken}'`).join('')

      if (!state.customFilter) return odataString;

      const filterPartStartIndex = odataString.indexOf('$filter=');
      if (filterPartStartIndex == -1) return `${odataString}&$filter=${state.customFilter}`;

      const filterPartEndIndex = odataString.indexOf('&', filterPartStartIndex);
      const filterPart = odataString.substring(
        filterPartStartIndex,
        filterPartEndIndex != -1 ? filterPartEndIndex : undefined,
      );

      odataString = odataString.replace(
        filterPart,
        `$filter=(${state.customFilter}) and (${filterPart.substring(filterPart.indexOf('=') + 1)})`,
      );
      return odataString;
    }

    return '';
  }

  private static mapFilterOperator(operator: string): string {
    switch (operator) {
      case 'EqualTo':
      case 'eq':
        return 'eq';
      case 'NotEqualTo':
      case 'neq':
      case 'ne':
        return 'ne';
      case 'GreaterThan':
      case 'gt':
        return 'gt';
      case 'GreaterThanOrEqual':
      case 'gte':
      case 'ge':
        return 'ge';
      case 'LessThan':
      case 'lt':
        return 'lt';
      case 'LessThanOrEqual':
      case 'lte':
      case 'le':
        return 'le';
      default:
        return operator;
    }
  }
}
